import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BED_CATEGORY_PATH = "/bed-category/v1";

export const getBedCategoryApi = async (params) =>
  await getRequest(BED_CATEGORY_PATH, params);

export const getBedCategoryByIdApi = async (id) =>
  await getRequest(`${BED_CATEGORY_PATH}/${id}`);

export const addBedCategoryApi = async (body) =>
  await postRequest(BED_CATEGORY_PATH, body);

export const updateBedCategoryApi = async (body) =>
  await putRequest(`${BED_CATEGORY_PATH}/${body?._id}`, body);

export const deleteBedCategoryByIdApi = async (id) =>
  await deleteRequest(`${BED_CATEGORY_PATH}/${id}`);
